/** Deployment region baked into each published SDK package by tsup. */
export type XmaxSdkRegion = 'cn' | 'global'
export type XmaxSdkEnvironment = 'prod' | 'test' | 'dev'

export function resolveXmaxSdkBuildEnvironment(
  value: string | undefined,
): XmaxSdkEnvironment {
  if (value === 'prod' || value === 'test' || value === 'dev') return value
  return 'prod'
}

export function resolveXmaxReportEnvironment(
  reportSource: unknown,
  buildEnvironment: XmaxSdkEnvironment,
): XmaxSdkEnvironment {
  return reportSource === 'open_platform' ? buildEnvironment : 'prod'
}

/** Falls back to the domestic package for local development and unconfigured builds. */
export const XMAX_SDK_BUILD_REGION: XmaxSdkRegion =
  process.env.XMAX_SDK_REGION === 'global' ? 'global' : 'cn'

export const XMAX_SDK_BUILD_ENV: XmaxSdkEnvironment =
  resolveXmaxSdkBuildEnvironment(process.env.XMAX_SDK_ENV)

/** Default UI/error language associated with the published package. */
export const XMAX_SDK_DEFAULT_LOCALE: 'zh-CN' | 'en-US' =
  XMAX_SDK_BUILD_REGION === 'global' ? 'en-US' : 'zh-CN'
